/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Admin Portal - API
 * # Introduction    This API provides access to admin and customer management.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Forbidden,
  MeterResponseModel,
  NotFound,
  Unauthorized,
} from '../models';

export interface CrmInstallationsGasDeleteMeterDeviceRequest {
    id: string;
    configurationId: string;
}

export interface CrmInstallationsGasGetMeterDeviceRequest {
    id: string;
    deviceId: string;
}

export interface CrmInstallationsGasGetMeterDevicesRequest {
    id: string;
    deviceCategory?: string;
}

/**
 * 
 */
export class CRMInstallationsGasApi extends runtime.BaseAPI {

    /**
     * Permanently removes a gas meter installation configuration from the customer account. This action cannot be undone and will delete all associated configuration data
     * Remove Gas Meter Installation
     */
    async crmInstallationsGasDeleteMeterDeviceRaw(requestParameters: CrmInstallationsGasDeleteMeterDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsGasDeleteMeterDevice.');
        }

        if (requestParameters.configurationId === null || requestParameters.configurationId === undefined) {
            throw new runtime.RequiredError('configurationId','Required parameter requestParameters.configurationId was null or undefined when calling crmInstallationsGasDeleteMeterDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gas/{configurationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"configurationId"}}`, encodeURIComponent(String(requestParameters.configurationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently removes a gas meter installation configuration from the customer account. This action cannot be undone and will delete all associated configuration data
     * Remove Gas Meter Installation
     */
    async crmInstallationsGasDeleteMeterDevice(requestParameters: CrmInstallationsGasDeleteMeterDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.crmInstallationsGasDeleteMeterDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves detailed information about a specific gas meter installation by device ID. Returns meter configuration, serial numbers, installation date, and consumption tracking settings
     * Get Specific Gas Meter Installation
     */
    async crmInstallationsGasGetMeterDeviceRaw(requestParameters: CrmInstallationsGasGetMeterDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeterResponseModel>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsGasGetMeterDevice.');
        }

        if (requestParameters.deviceId === null || requestParameters.deviceId === undefined) {
            throw new runtime.RequiredError('deviceId','Required parameter requestParameters.deviceId was null or undefined when calling crmInstallationsGasGetMeterDevice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gas/{deviceId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"deviceId"}}`, encodeURIComponent(String(requestParameters.deviceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves detailed information about a specific gas meter installation by device ID. Returns meter configuration, serial numbers, installation date, and consumption tracking settings
     * Get Specific Gas Meter Installation
     */
    async crmInstallationsGasGetMeterDevice(requestParameters: CrmInstallationsGasGetMeterDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeterResponseModel> {
        const response = await this.crmInstallationsGasGetMeterDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all gas meter installations for a specific customer. Includes meter configurations, consumption data access points, and installation details. Optional filtering by device category
     * Get All Gas Meter Installations
     */
    async crmInstallationsGasGetMeterDevicesRaw(requestParameters: CrmInstallationsGasGetMeterDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeterResponseModel>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling crmInstallationsGasGetMeterDevices.');
        }

        const queryParameters: any = {};

        if (requestParameters.deviceCategory !== undefined) {
            queryParameters['device-category'] = requestParameters.deviceCategory;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        const response = await this.request({
            path: `/api/v1/customers/{id}/installations/gas`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves all gas meter installations for a specific customer. Includes meter configurations, consumption data access points, and installation details. Optional filtering by device category
     * Get All Gas Meter Installations
     */
    async crmInstallationsGasGetMeterDevices(requestParameters: CrmInstallationsGasGetMeterDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeterResponseModel>> {
        const response = await this.crmInstallationsGasGetMeterDevicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
